import { render, staticRenderFns } from "./CourseThumb.vue?vue&type=template&id=71e2b6fe&scoped=true&"
import script from "./CourseThumb.vue?vue&type=script&lang=js&"
export * from "./CourseThumb.vue?vue&type=script&lang=js&"
import style0 from "./CourseThumb.vue?vue&type=style&index=0&id=71e2b6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2b6fe",
  null
  
)

/* custom blocks */
import block0 from "./CourseThumb.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports